import { useState, useRef } from 'react';

/**
 * Hook personalizado para manejar captura de imágenes desde cámara y galería
 */
export const useImageCapture = () => {
  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const pendingImageCallbackRef = useRef(null);
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);

  // Función para convertir archivo a base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  // Abrir modal de selección de fuente
  const openImageSourceModal = (callback) => {
    console.log('📸 Opening modal with callback:', callback);
    pendingImageCallbackRef.current = callback;
    setIsSourceModalOpen(true);
  };

  // Cerrar modal de selección de fuente
  const closeImageSourceModal = () => {
    setIsSourceModalOpen(false);
    pendingImageCallbackRef.current = null;
  };

  // Manejar selección de fuente de imagen
  const handleImageSourceSelect = (source) => {
    console.log('📸 Source selected:', source);
    console.log('📸 Current callback before selection:', pendingImageCallbackRef.current);
    
    // NO cerrar el modal aquí, mantener el callback activo
    if (source === 'camera') {
      // Activar input de cámara
      if (cameraInputRef.current) {
        cameraInputRef.current.click();
      }
    } else if (source === 'gallery') {
      // Activar input de galería
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }
  };

  // Manejar cambio en input de archivo (tanto cámara como galería)
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    console.log('📸 File selected:', file);
    console.log('📸 Pending callback:', pendingImageCallbackRef.current);
    
    if (file && pendingImageCallbackRef.current) {
      try {
        const base64Url = await convertToBase64(file);
        console.log('📸 Base64 converted, length:', base64Url.length);
        pendingImageCallbackRef.current(base64Url);
        console.log('📸 Callback executed');
        
        // Cerrar modal y limpiar callback después de ejecutar
        setIsSourceModalOpen(false);
        pendingImageCallbackRef.current = null;
      } catch (error) {
        console.error('❌ Error converting image to base64:', error);
      }
    } else {
      console.log('❌ No file or no callback available');
    }
    // Limpiar el input para permitir seleccionar el mismo archivo otra vez
    e.target.value = '';
  };

  // Crear inputs ocultos para cámara y galería
  const createHiddenInputs = () => (
    <>
      {/* Input para galería */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      {/* Input para cámara */}
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );

  return {
    isSourceModalOpen,
    openImageSourceModal,
    closeImageSourceModal,
    handleImageSourceSelect,
    createHiddenInputs,
    convertToBase64
  };
};

